import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "perks-button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, { "class-name": "navmenu-right-container" }, {
    default: _withCtx(() => [
      (_ctx.state.build.info.phase === 'level')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_GenericButton, {
              class: "image-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ui.showPerks = !_ctx.ui.showPerks)),
              "is-active": _ctx.ui.showPerks,
              "image-src": require('@/assets/img/level-perks-btn.png'),
              height: "40px",
              width: "40px",
              transparent: ""
            }, null, 8, ["is-active", "image-src"]),
            _createVNode(_component_GenericButton, {
              class: "image-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ui.showSupportPerks = !_ctx.ui.showSupportPerks)),
              "is-active": _ctx.ui.showSupportPerks,
              "image-src": require('@/assets/img/support-perks-btn.png'),
              height: "40px",
              width: "40px",
              transparent: ""
            }, null, 8, ["is-active", "image-src"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}